import { produce } from "immer";

import { learnerRatingTypes as types } from "../actions";
import { RatingStateType } from "../../../utils/types/Learner/rating/RatingState";

const defaultState: RatingStateType = {
  ratings: [],
  loading: false,
  loaded: false,
};

const handleSetRatings = (state: RatingStateType, payload: any) => {
  state.ratings = payload.ratings;
  state.loaded = true;
  state.loading = false;

  return state;
};

export default produce((state: RatingStateType = defaultState, action) => {
  switch (action.type) {
    case types.LEARNER_SET_RATING:
      return handleSetRatings(state, action.payload);
    case types.LEARNER_GET_RATING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
});
